import { createFileRoute } from '@tanstack/react-router'
import { ProjectPermalinkPage } from '@/features/account/pages/projects/project-permalink-page'

/**
 * The project's canonical permalink. A collaborator who can open the project
 * lands in the project workspace; a discoverer still gets the F3 locked
 * preview. The access roster moved to `./access`.
 */
export const Route = createFileRoute('/_ws/w/$workspaceId/projects/$projectId/')({
  component: ProjectPermalinkPage,
})
